import { Observable } from 'rxjs';

/**
 * Настройки организации из админки: плоский список `key → value`, организация определяется по домену.
 * Токен не нужен. Ключей карт может не быть вовсе — это штатная конфигурация, а не ошибка.
 */
export abstract class SettingsApi {
  /** Один запрос за сессию: результат кеширует реализация, вызывать можно из любого потребителя. */
  abstract load(): Observable<ReadonlyMap<string, string>>;
}
